/**
 * Configurazione runtime caricata da `config.json` servito da CloudFront.
 * Nessun secret lato client: solo valori pubblici (issuer, clientId, redirect).
 * Design ref: "Auth flow OIDC" — config runtime esposta al browser via config.json.
 */
export interface OidcConfig {
  authority: string;
  clientId: string;
  redirectUri: string;
  postLogoutRedirectUri: string;
  scope: string;
}

export interface RuntimeConfig {
  apiBaseUrl: string;
  oidc: OidcConfig;
}

let cached: Promise<RuntimeConfig> | null = null;

/**
 * Carica (una sola volta) la configurazione runtime dal file statico `config.json`.
 */
export function loadConfig(): Promise<RuntimeConfig> {
  if (!cached) {
    cached = fetch('/config.json', { cache: 'no-store' }).then((res) => {
      if (!res.ok) {
        throw new Error(`Impossibile caricare config.json (${res.status})`);
      }
      return res.json() as Promise<RuntimeConfig>;
    });
  }
  return cached;
}
